import CreateAccountForm from './CreateAccountForm'
import enhance from './CreateAccountForm.enhancer'

export default enhance(CreateAccountForm)



// WEBPACK FOOTER //
// ./src/components/organisms/CreateAccountForm/index.js